export function getFamilyMemberReferenceUpdates(members, deletedMemberId) {
  return members.flatMap((member) => {
    if (member.id === deletedMemberId) return [];
    const parentIds = Array.isArray(member.parentIds) ? member.parentIds : [];
    const spouseIds = Array.isArray(member.spouseIds) ? member.spouseIds : [];
    const nextParentIds = parentIds.filter((id) => id !== deletedMemberId);
    const nextSpouseIds = spouseIds.filter((id) => id !== deletedMemberId);
    if (nextParentIds.length === parentIds.length && nextSpouseIds.length === spouseIds.length) return [];
    return [{ id: member.id, parentIds: nextParentIds, spouseIds: nextSpouseIds }];
  });
}

export function getFamilyRelationshipError(members, memberId, parentIds, spouseIds) {
  const memberIds = new Set(members.map((member) => member.id));
  const parents = [...new Set(parentIds || [])];
  const spouses = [...new Set(spouseIds || [])];

  if (parents.length > 2) return 'Choose no more than two parents.';
  if (parents.includes(memberId)) return 'A person cannot be their own parent.';
  if (spouses.includes(memberId)) return 'A person cannot be their own spouse or partner.';
  if (parents.some((id) => !memberIds.has(id))) return 'Choose parents that are still in your family tree.';
  if (spouses.some((id) => !memberIds.has(id))) return 'Choose spouses or partners that are still in your family tree.';

  const byId = new Map(members.map((member) => [member.id, member]));
  const childrenByParent = new Map(members.map((member) => [member.id, []]));
  members.forEach((member) => {
    const memberParents = member.id === memberId ? parents : (member.parentIds || []);
    memberParents.forEach((parentId) => {
      if (childrenByParent.has(parentId)) childrenByParent.get(parentId).push(member.id);
    });
  });
  const reachesDescendant = (ancestorId, descendantId) => {
    const pending = [ancestorId];
    const visited = new Set();
    while (pending.length) {
      const currentId = pending.pop();
      if (currentId === descendantId) return true;
      if (visited.has(currentId)) continue;
      visited.add(currentId);
      pending.push(...(childrenByParent.get(currentId) || []));
    }
    return false;
  };
  const hasMemberAsAncestor = (currentId, visited = new Set()) => {
    if (currentId === memberId) return true;
    if (visited.has(currentId)) return false;
    visited.add(currentId);
    const current = byId.get(currentId);
    return (current?.parentIds || []).some((parentId) => hasMemberAsAncestor(parentId, visited));
  };

  if (parents.some((parentId) => hasMemberAsAncestor(parentId))) {
    return 'This parent relationship would create a family cycle.';
  }
  if (spouses.some((spouseId) =>
    reachesDescendant(memberId, spouseId) || reachesDescendant(spouseId, memberId))) {
    return 'A spouse or partner cannot be an ancestor or descendant.';
  }
  return '';
}
